import axios from "axios";
import { apiUrl } from "config";

export type AcceptTermsData = {
  address: string;
  signature?: string;
  tokenIds: number[];
};

export const acceptTerms = async ({
  address,
  tokenIds,
  signature,
}: AcceptTermsData): Promise<void> => {
  await axios.post<{ tokenId: number; quantity: number }[]>(
    "/terms/accept",
    { tokenIds, signature, address },
    {
      baseURL: apiUrl,
    }
  );
  return;
};
